import i18n from '@/lang/i18n'
import { ENTITIES, ENTITY_TYPES, ENTITIES_BY_ID } from '@/entities/entities'
import { ROLE_TYPES } from '@/entities/users'

const logo = require('../assets/images/logos/qualitas-logo.svg')

const normalizeNavItem = ({ label, path, children }) => ({
    label,
    to: { name: 'AdminEntityList', params: { entityKey: path } },
    children,
})

const navbarBase = [
    ENTITIES_BY_ID[ENTITY_TYPES.GPS],
    {
        ...ENTITIES_BY_ID[ENTITY_TYPES.FUNDS],
        children: [
            ENTITIES_BY_ID[ENTITY_TYPES.FUNDS],
            ENTITIES_BY_ID[ENTITY_TYPES.FUNDS_PERF],
        ].map(normalizeNavItem),
    },
    {
        ...ENTITIES_BY_ID[ENTITY_TYPES.TRANSACTIONS],
        children: [
            ENTITIES_BY_ID[ENTITY_TYPES.TRANSACTIONS],
            ENTITIES_BY_ID[ENTITY_TYPES.TRANSACTIONS_PERF],
        ].map(normalizeNavItem),
    },
    {
        ...ENTITIES_BY_ID[ENTITY_TYPES.COMPANIES],
        children: [
            ENTITIES_BY_ID[ENTITY_TYPES.COMPANIES],
            ENTITIES_BY_ID[ENTITY_TYPES.COMPANIES_EVOL],
        ].map(normalizeNavItem),
    },
    {
        ...ENTITIES_BY_ID[ENTITY_TYPES.LPS],
        children: [
            ENTITIES_BY_ID[ENTITY_TYPES.LPS],
            ENTITIES_BY_ID[ENTITY_TYPES.LPS_INVESTMENTS],
            ENTITIES_BY_ID[ENTITY_TYPES.LPS_SECONDARY_TRANS],
        ].map(normalizeNavItem),
    },
].map(normalizeNavItem)

const navbarEditor = [
    {
        key: 'SCHEMA',
        permissions: [ROLE_TYPES.ADMIN, ROLE_TYPES.EDIT],
        icon: 'sliders',
        label: i18n.t('admin.navigation.schema.main'),
        to: { name: 'AdminBuilder' },
        children: [
            ...ENTITIES.map(({ label, name }) => ({
                label,
                to: { name },
            })),
            {
                icon: 'folder',
                label: i18n.t('admin.navigation.schema.dicts'),
                to: { name: 'Dicts' },
            },
            {
                icon: 'folder',
                label: i18n.t('admin.navigation.schema.transforms'),
                to: { name: 'Transforms' },
            },
            {
                icon: 'folder',
                label: i18n.t('admin.navigation.schema.styles'),
                to: { name: 'Styles' },
            },
        ],
    },
    {
        key: 'USERS',
        icon: 'users',
        label: i18n.t('admin.navigation.users'),
        to: { name: 'AdminUsers' },
    },
    {
        key: 'AUDIT',
        permissions: [ROLE_TYPES.ADMIN],
        icon: 'shield',
        label: i18n.t('admin.navigation.audit'),
        to: { name: 'AdminAudit' },
    },
]

export default {
    title: 'Qualitas',
    description: 'Qualitas Admin',
    logo,
    head: {
        navbar: navbarBase,
        menu: [
            ...navbarEditor,
            {
                key: 'EXIT',
                icon: 'exit',
                label: i18n.t('admin.navigation.signout'),
                to: { name: 'Signout' },
                style: ['separator-top'],
            },
        ],
    },
    navbar: [
        ...navbarBase,
        ...navbarEditor,
    ],
}
